export default __webpack_public_path__ + "static/media/weiloon.582bf09f.png";